import React, { useMemo, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Box, Grid, Button } from "@mui/material";
import { InputField } from "../../components/ui/Inputs";
import SelectOptions from "../../components/ui/SelectOptions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import { decrypt } from "../../utils/crypto";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";

interface DocumentFormValues {
    docType: number;
    // status: string;
    docName: string;
    // docType: string;
}
interface AddMoreDocumentFormProps {
    applicants: any;
    onClose: () => void;
    tabIndex: number;
    documentCategories: any;
    documentCategoryId: number;
    masterDocumentList: any;
    modelType: string;
    documentData: any;
    hasNotRequiredDocument: any;
    setDocumentData: (data: any) => void;
    handleGetMasterDocumentList: (documentCategoryId: number) => void;
    getDocumentCategoriesViaAPI: () => void;
}

const AddMoreDocumentForm: React.FC<AddMoreDocumentFormProps> = ({
    applicants,
    onClose,
    tabIndex,
    documentCategories,
    documentCategoryId,
    masterDocumentList,
    handleGetMasterDocumentList,
    modelType,
    documentData,
    setDocumentData,
    hasNotRequiredDocument,
    getDocumentCategoriesViaAPI }) => {
    const formData = useSelector((state: RootState) => state.stepper.formData);
    const userProfile = useSelector((state: RootState) => state.auth.userProfile);
    const submissionTrackingId: any = useSelector(
        (state: RootState) => state.stepper.trackingId
    );
    const dispatch = useDispatch();
    const [docNameError, setDocNameError] = useState("");

    // Hide Academic Documents & Entrance Exam Documents in Type of document dropdown when co-applicant (tabIndex > 0)
    const documentCategoriesForDropdown = useMemo(() => {
        if (tabIndex <= 0) return documentCategories;
        return (documentCategories || []).filter(
            (c: any) =>
                c?.label !== "Academic Documents" && c?.label !== "Entrance Exam Documents"
        );
    }, [tabIndex, documentCategories]);

    const initialValues: DocumentFormValues = {
        docType: 0,
        docName: "",
    };

    const validationSchema = Yup.object({
        docType: Yup.number().required("Document type is required"),
        docName: Yup.string().required("Document name is required"),
    });

    const handleAddMoreDocument = async (values: any) => {

        if (values?.docName == "Others") {
            const payload = {
                "productType": formData?.product,
                "typeOfApplicant": tabIndex == 0 ? "Applicant" : applicants?.[tabIndex],
                "docName": values?.docOtherName,
                "documentCategoryId": modelType == "addSubDocument" ? documentCategoryId : values?.docType,
                "employmentCategory": tabIndex == 0 ? formData?.employmentType || formData?.applicantType : formData?.[`employmentCoApplicant${applicants?.[tabIndex]?.split(" ")?.[1]}employmentType`] || formData?.applicantType,
                "isOtherDoc": true,
                "trackingId": submissionTrackingId
            }

            await eligibilityCheckServices.createOtherDocumentApi(payload)
                .then((response: any) => {
                    getDocumentCategoriesViaAPI()
                    onClose();
                    // if (modelType === "addSubDocument") {
                    //     setDocumentData((prevDocumentData: any) =>
                    //         prevDocumentData.map((category: any) =>
                    //             category.id === documentCategoryId
                    //                 ? { ...category, documents: [...category.documents, response?.data?.data] }
                    //                 : category
                    //         )
                    //     );

                    // }
                    // if (modelType === "addMainDocument") {
                    //     setDocumentData((prevDocumentData: any) =>
                    //         prevDocumentData.map((category: any) =>
                    //             category.id === values?.docType
                    //                 ? { ...category, documents: [...category.documents, response?.data?.data] }
                    //                 : category
                    //         )
                    //     );
                    //     onClose();
                    // }
                    dispatch(
                        setStatusPopup({
                            status: "success",
                            message: response?.data?.message,
                        })
                    );
                }).catch((error) => {
                    dispatch(
                        setStatusPopup({
                            status: "error",
                            message: error?.response?.data?.message,
                        })
                    );
                })
            return
        }


        if (modelType === "addSubDocument") {
            // Find the document to add and mark it as default
            const documentToAdd = hasNotRequiredDocument.find((item: any) => item?.id === values?.docName);

            if (!documentToAdd) {
                console.error("Document not found in hasNotRequiredDocument");
                return;
            }

            // Create a new document object to avoid mutating the original
            const updatedDocument = { ...documentToAdd, byDefault: true };

            // Update document data immutably
            setDocumentData((prevDocumentData: any) =>
                prevDocumentData.map((category: any) =>
                    category.id === documentCategoryId ? { ...category, documents: [...category.documents, updatedDocument] } : category
                )
            );
            // getDocumentCategoriesViaAPI()
            onClose();
        }

        if (modelType === "addMainDocument") {
            const documentToAdd = hasNotRequiredDocument.find((item: any) => item?.id === values?.docName);
            const existingCategory = documentData.find((item: any) => item?.id === values?.docType);
            const categoryInfo = documentCategories.find((elem: any) => elem?.value === values?.docType);

            if (!documentToAdd) {
                console.error("Document not found in hasNotRequiredDocument");
                return;
            }

            if (existingCategory && Object.keys(existingCategory).length > 0) {
                // Update existing category
                const updatedDocument = { ...documentToAdd, byDefault: true };
                setDocumentData((prevDocumentData: any) =>
                    prevDocumentData.map((category: any) =>
                        category.id === values?.docType
                            ? {
                                ...category,
                                isMand: true,
                                documents: [...category.documents, updatedDocument]
                            }
                            : category
                    )
                );
            } else {
                // Create new category
                if (!categoryInfo) {
                    console.error("Category not found in documentCategories");
                    return;
                }

                const newCategory = {
                    id: categoryInfo.value,
                    name: categoryInfo.label,
                    isMand: true,
                    documents: [{ ...documentToAdd, byDefault: true }]
                };

                setDocumentData((prevDocumentData: any) => [...prevDocumentData, newCategory]);
            }
            // getDocumentCategoriesViaAPI()
            onClose();
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleAddMoreDocument}
        >
            {({ values, errors, touched, setFieldValue, isValid, dirty, setErrors, setFieldError, setFieldTouched }) => (
                <Form>
                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={2}>
                            {/* Document Name Field */}

                            <Grid item xs={12} sm={12}>
                                <Field name="docType">
                                    {({ field, meta }: any) => (
                                        <SelectOptions
                                            label="Type of document"
                                            value={field.value || documentCategoryId}
                                            onChange={(value: string | number) => {
                                                setFieldValue("docType", value);
                                                handleGetMasterDocumentList(Number(value));
                                            }}
                                            options={documentCategoriesForDropdown}
                                            isMandatory={true}
                                            error={!!(meta.touched && meta.error)}
                                            helperText={meta.touched && meta.error ? meta.error : ""}
                                            disabled={documentCategoryId > 0}
                                        />
                                    )}
                                </Field>
                            </Grid>

                            {/* Document Type Field */}
                            <Grid item xs={12} sm={12}>
                                <Field name="docName">
                                    {({ field, meta }: any) => (
                                        <SelectOptions
                                            label="Document Name"
                                            value={field.value}
                                            onChange={(value: string | number) => {
                                                const findObject = documentData.find((elem: any) => elem?.id == documentCategoryId || elem?.id == values?.docType)?.documents.find((item: any) => item?.id == value)
                                                if (findObject?.isMandatory || findObject?.byDefault || findObject?.userDocs?.length > 0) {
                                                    console.log("error")
                                                    setDocNameError("Document is already added");
                                                    setFieldTouched("docName", true);
                                                    setFieldValue("docName", value);
                                                } else {
                                                    setDocNameError("");
                                                    setFieldValue("docName", value);
                                                }
                                            }}
                                            options={masterDocumentList}
                                            isMandatory={true}
                                            error={!!(meta.touched && meta.error) || !!(docNameError && docNameError !== "")}
                                            helperText={(meta.touched && meta.error) || (docNameError && docNameError !== "") ? (meta.error || docNameError) : ""}
                                        />
                                    )}
                                </Field>
                            </Grid>

                            {values.docName == "Others" && (
                                <Grid item xs={12}>
                                    <Field name="docOtherName">
                                        {({ field, meta }: any) => (
                                            <div>
                                                <label
                                                    className="text-lable"
                                                    style={{ marginBottom: "5px", display: "block" }}
                                                >
                                                    Name of document <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <InputField
                                                    {...field}
                                                    fullWidth
                                                    // multiline
                                                    // rows={1}
                                                    placeholder="Name of document"
                                                    variant="outlined"
                                                    error={!!(meta.touched && meta.error)}
                                                    helperText={meta.touched && meta.error ? meta.error : ""}

                                                />
                                            </div>
                                        )}
                                    </Field>
                                </Grid>
                            )}


                        </Grid>

                        {/* Form Actions */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 2,
                                mt: 3,
                                pt: 2,
                                borderTop: "1px solid #eee",
                            }}
                        >
                            <Button
                                variant="outlined"
                                onClick={onClose}
                                sx={{
                                    textTransform: "none",
                                    borderColor: "#00b3b5",
                                    color: "#00b3b5",
                                    "&:hover": {
                                        borderColor: "#00999a",
                                        bgcolor: "#e0f7fa",
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={!isValid || !dirty || !!(docNameError && docNameError !== "")}
                                sx={{
                                    bgcolor: "#00b3b5",
                                    color: "#fff",
                                    "&:hover": {
                                        bgcolor: "#00999a",
                                    },
                                    "&:disabled": {
                                        bgcolor: "#e0e0e0",
                                        color: "#9e9e9e",
                                    },
                                    textTransform: "none",
                                }}
                            >
                                Add Document
                            </Button>
                        </Box>
                    </Box>
                </Form>
            )}
        </Formik>
    );

}

export default AddMoreDocumentForm;